export const diplomaRequests = [
  "diploma_request.steps.one",
  "diploma_request.steps.two",
  "diploma_request.steps.three",
];
